import { classNames } from "../../../../lib/classNames"

export type DropSide = "left" | "right"

export function DropIndicator({ side }: { side: DropSide }) {
  return (
    <div
      className={classNames(
        "z-21 bg-primary-default absolute inset-y-0 w-0.5",
        side === "left" ? "-left-px" : "-right-px"
      )}
    />
  )
}
